import { getResizeImage } from '~/components/Image';

type Props = {
  name?: string;
  description?: string;
  thumbnailImageUrl?: string;
  mainImageUrl?: string;
};

export function ShowcaseImageContainer({
  name,
  description,
  thumbnailImageUrl,
  mainImageUrl,
}: Props) {
  if (!thumbnailImageUrl && !mainImageUrl) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center gap-16 bg-secondary-air px-20 pb-20 pt-16">
      <div className="flex flex-col items-center">
        {thumbnailImageUrl && (
          <img
            src={getResizeImage({
              src: thumbnailImageUrl,
              width: 80,
            })}
            alt="thumbnail"
            className="mb-8 size-80 rounded-12"
          />
        )}
        <h2 className="mb-2 text-hint typo-footnote300-regular">{name}</h2>
        <p className="mt-4 typo-heading100-bold">{description}</p>
      </div>
      {mainImageUrl && (
        <img
          src={getResizeImage({
            src: mainImageUrl,
          })}
          alt="main"
          className="rounded-16"
        />
      )}
    </div>
  );
}
